import { cn } from "@/ui/lib/cn";

interface ProgressBarProps {
  current: number;
  total: number;
  phaseLabel: string;
}

/**
 * Mobile: phase label on its own row, then a row of "Step N of M" +
 * flex-grow dots that fill the available width.
 * Desktop: single row with phase label on the left, step counter +
 * fixed-width dots on the right.
 */
export function ProgressBar({ current, total, phaseLabel }: ProgressBarProps) {
  return (
    <div className="flex flex-col gap-2 border-b border-border pb-4 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
      <p className="text-xs uppercase tracking-wider text-muted-foreground">{phaseLabel}</p>
      <div className="flex items-center gap-3">
        <span className="shrink-0 text-xs text-muted-foreground">
          Step {current + 1} of {total}
        </span>
        <div className="flex flex-1 gap-0.5 sm:flex-initial sm:gap-1">
          {Array.from({ length: total }).map((_, i) => (
            <div
              key={i}
              className={cn(
                "h-1 flex-1 rounded-full transition-colors sm:w-5 sm:flex-initial",
                i < current ? "bg-muted-foreground" :
                i === current ? "bg-primary" : "bg-border",
              )}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
